/**
 * Created by mauget on 1/23/16.
 */

// WorkflowPageView.js

import $            from 'jquery';
import _            from 'lodash';
import Immutable    from 'immutable';
import widgetUtil from 'util/WidgetUtil';
import fabric                   from 'fabric.js/dist/fabric.require.js';
import connectionController     from 'ConnectionController.js';
import factoryService           from 'FactoryService.js';
import dragDropService          from 'DragDropService.js';
import constants                from 'Constants.js';
import focusController          from 'FocusController.js';
import listService              from 'ListService.js';
import eventBus                 from 'EventBus';
import AttributesView           from 'properties/AttributesView.js'
import TabSettingsView          from 'behaviors/properties/TabSettingsView.js';
import TabSummaryView           from 'behaviors/properties/TabSummaryView.js';
import CustomBehaviorView       from 'workflow/properties/main/CustomBehaviorView.js';
import BaseGraphicsPageView     from 'form/BaseGraphicsPageView.js';
import { ConnectionArrowClass } from 'shapelib/ConnectionArrowClass.js';
import { TooltipClass }         from 'shapelib/TooltipClass.js';
import util                     from 'util/Util.js';
import objectUtil               from 'util/ObjectUtil.js';
import textConstants            from 'TextConstants';
import undoService              from 'UndoService';
import Spinner                  from 'spin/spin';
import leftPanelState           from "LeftPanelStateService";

import template from 'form/graphic-page.ejs';

const TOOLTIP_WIDTH = 350;
const MIN_CONTROL_WIDTH = 111;
const MIN_CONTROL_HEIGHT = 41;
//==========================================================================================
// A BackBone view of a PerfectForms layout Fabric.js canvas-based page.
// Lou Mauget, January 23, 2015
//==========================================================================================
class WorkflowPageView extends BaseGraphicsPageView {

    initialize( opts = {} ) {
        this.options = opts || {};

        // Hold id of the top page/canvas overlay rectangle, not the background grid canvas
        this.canvasId = constants.PAGESEL_ID;
        this.id = constants.PAGESEL_ID;
        this.listenTo( eventBus, 'resizeWorkflowCanvas', this.resizeCanvas );
        this.listenTo(eventBus, 'redrawWorkflowGrid', this.drawGrid);
        this.listenTo(eventBus, 'selectWorkflowConnection', this.selectConnectionArrow);
        this.listenTo( eventBus, 'selectSingleItemForWorkflow', this.triggerItemSelection);

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        setTimeout(() => {
            // display workflow properties
            widgetUtil.removeAllBezeierControlPoints();
            listService.currentSelectedPathId = undefined;
            if (listService.itemSearched && listService.itemSearched !== 0) {
                const selectedObject = listService.getCanvasObjectById(listService.itemSearched);
                this.model = selectedObject.model;
                listService.itemSearched = 0;
            }
            this.switchProperties( this.model );
            listService.fcanvas.renderAll();
            util.updateHelpDocumentationLink('workflow');
            leftPanelState.restore();
            window.setTimeout(() => {
                spinner.stop();
            }, 0);
        }, 100);

        return this;
    }


    // DRY. Maybe refactor these props to a common place? These duplicated in MobileDragDropService.js
    //==========================================================================================
    // Property: Perfect Forms canvas page position within DOM window
    //==========================================================================================
    get pagePos() {
        const offset = $(this.canvasId).offset();
        return {
            top:  offset.top  - $(window).scrollTop(),
            left: offset.left - $(window).scrollLeft()
        };
    }


    //==========================================================================================
    // Property: Perfect Forms canvas page width and height
    //==========================================================================================
    get pageDim() {
        return {
            width:  $(this.canvasId).width(),
            height: $(this.canvasId).height()
        };
    }


    //==========================================================================================
    // Property: Perfect Forms canvas page rectangle in offset coordinates compensated for
    // window scroll position.
    //==========================================================================================
    get pageRect() {
        return {
            top:    this.pagePos.top,
            left:   this.pagePos.left,
            height: this.pageDim.height,
            width:  this.pageDim.width
        };
    }


    //===============================================================================
    // The context width / height settings are the means to size an HTML5 canvas.
    //===============================================================================
    resizeCanvas( rawId, width, height ){
        const c = $( constants.ID_SEL + rawId );
        const ctx = c[0].getContext('2d');

        this.model.set('width', width, constants.MODEL_SILENT);
        this.model.set('height', height, constants.MODEL_SILENT);        
        listService.workflowProperties._root.entries[0][1] = width;
        listService.workflowProperties._root.entries[1][1] = height;

        // set width and height
        ctx.canvas.width = width;
        ctx.canvas.height = height;


        const fcanvas = listService.fcanvas;
        if (fcanvas) {
            fcanvas.setWidth(width);
            fcanvas.setHeight(height);
            fcanvas.calcOffset();

            $('.canvas-container').css({'width': width, 'height': height});

            // Replaces the grid and background
            this.drawGrid();
        }


        return ctx;
    }


    // TODO Hoist to base class
    //==========================================================================
    // Paints a grid on the visible, bottom canvas.
    //==========================================================================
    drawGrid( ) {
        const            
            width = listService.workflowProperties.get('width'),
            height = listService.workflowProperties.get('height'),
            gridSize = this.model.attributes.gridWidth;

        const gridCanvas = new fabric.StaticCanvas(constants.GRID_CANVAS_RAW_ID,
            {
                backgroundColor: constants.BEH_BG_CLR,  // Picked from AS version
                width: width,
                height: height,
                selection: false,
                renderOnAddRemove: false
            });

        const strokeStyle = constants.BEH_GRIDLINE_CLR;

        for (let x = gridSize; x < width; x += gridSize) {
            gridCanvas.add(new fabric.Line([0, 0, 0, height], {
                left: x,
                top: 0,
                stroke: strokeStyle,
                selectable: false,
                hasControls : false,
                hasRotatingPoint: false,
                hasBorders: false
            }));
        }

        for (let y = gridSize; y < height; y += gridSize) {
            gridCanvas.add(new fabric.Line([0, 0, width, 0], {
                left: 0,
                top: y,
                stroke: strokeStyle,
                selectable: false,
                hasControls : false,
                hasRotatingPoint: false,
                hasBorders: false
            }));
        }

        gridCanvas.renderAll();
    }


    // TODO Hoist to base class
    //==========================================================================
    // Create fabric.js canvas wrapper for properly sized HTML canvas.
    // Draw the grid on the fabric canvas.
    //==========================================================================
    createFabricCanvas(rawCanvasId ) {

        // create a wrapper around native canvas element (by id )
        const transparentColor = 'rgba(0, 0, 0, 0.0)';
        listService.fcanvas = new fabric.Canvas( rawCanvasId, {
            backgroundColor: transparentColor,
            selectionColor: 'rgba(100,100,100,0.3)',
            renderOnAddRemove: false,
            selectionLineWidth: 1 }
        );

        return listService.fcanvas;
    }


    //==========================================================================
    // For Behaviors = fabricjs canvas:
    // Start specialized listeners that operate outside of BackBaone.
    // They act together  to implement drag/drop/focus behaviors on the page.
    //==========================================================================
    startWorkflowPageListeners(canvas2Id ) {

        dragDropService.listenForDropWorkflow( canvas2Id ) ;
        dragDropService.listenForFactoryDragStartWorkflow( factoryService.workflowFactories );
        dragDropService.listenForDragEnd(constants.CONTENT_ID);
        focusController.startControlFocusListeners( $(canvas2Id) );
    }


    //==========================================================================
    // Behavior layout size is that form. Make it so.
    //==========================================================================
    measureForm(formId ) {
        const $formId = $(formId);
        const result = { width: $formId.width(),  height: $formId.height() }
        return result;
    }

    isValidWorkflowObject( obj ) {
        return obj.target.model && obj.target.model.get('factoryKey') === 'workflow_stage';
    }

    //==========================================================================
    // Initializes the workflow canvas. Unlike the layout canvas, we draw
    // widgets on it.
    //==========================================================================
    initCanvas() {

        // Future: a user-settable page property:
        //this.dim = { height: 900, width: 700 };
        this.dim = { height: listService.workflowProperties.get('height'), width: listService.workflowProperties.get('width') };
        //this.dim = this.measureForm( constants.FORM_ID );
        const bottom_margin = 30;
        const right_margin = 4;

        // Set size of native canvas
        const canvasRawId = 'aPageSel';
        const ctx = this.resizeCanvas( canvasRawId, this.dim.width, this.dim.height );
        const fcanvas = this.createFabricCanvas( canvasRawId );
        fcanvas.perPixelTargetFind = true;
        fcanvas.targetFindTolerance = constants.CONNECTION_LINE_TOLERANCE;

        this.drawGrid();

        const that = this;


        // Setup the click event so that the widgets can be selected and the Properties can be rendered.
        fcanvas.off('mouse:down');

        fcanvas.on('mouse:down', function(option) {

            /*console.log("Objects in canvas W ", fcanvas.getObjects().map(o => {
                if (o.model.attributes.factoryKey === "connection_arrow") {
                    return o
                } 
            } 
            ).filter(o => o !== undefined));*/

            //console.log("Options", option);

            // PF-3892: Show available edit menu options
            listService.countingValidObjects();
            util.validateMenuItems( listService.selectedCount );

            if (option.target && option.target.type === 'group') {
                const obj = option.target;
                if (!obj.model) {
                    return;
                }

                widgetUtil.removeAllBezeierControlPoints();
                listService.currentSelectedPathId = undefined;

                // Cache current position of PerfectForms widget custom property
                obj.prevPos = {'left': obj.left, 'top': obj.top};

            }else if (option.target && option.target.type === 'ConnectionArrow') {
/*                  NOT necessary.  selectWorkflowConnection event will take care of this, and we will avoid
                  problems on rendering workflow connection properties more than one time (which is causing
                  to create 3 or more edit behavior buttons and causing to have 3 behavior canvas at same time*/
//                that.selectConnectionArrow(option.target);
            } else if (!option.target) {

                widgetUtil.removeAllBezeierControlPoints();
                listService.currentSelectedPathId = undefined;

                that.switchProperties(that.model);

                // PF-4075 Initializing behavior selection once canvas group is deselected.

                _.forEach(listService.workflowStages.toArray(),stage=>{
                    stage.model.set('selected',false,{silent:true});
                });

                _.forEach(listService.workflowComments.toArray(),comment=>{
                    comment.model.set('selected',false,{silent:true});
                });


                listService.fcanvas.renderAll();
                util.updateHelpDocumentationLink('workflow');
            }
        });

        fcanvas.off('mouse:up');
        fcanvas.on('mouse:up', option => {

            if (!option.target) {
                // display workflow properties
                widgetUtil.removeAllBezeierControlPoints();
                listService.currentSelectedPathId = undefined;

                that.switchProperties(that.model);
                listService.fcanvas.renderAll();
                const activeGroup = listService.fcanvas.getActiveGroup();
                if (activeGroup) {
                    util.updateHelpDocumentationLink('workflow_group');
                } else {
                    util.updateHelpDocumentationLink('workflow');
                }
            }else {
                const obj = option.target;
                switch (option.target.type) {
                    case 'ConnectionArrow':

                        widgetUtil.removeAllBezeierControlPoints();
/*                  NOT necessary.  selectWorkflowConnection event will take care of this, and we will avoid
                  problems on rendering workflow connection properties more than one time (which is causing
                  to create 3 or more edit behavior buttons and causing to have 3 behavior canvas at same time*/
//                        that.selectConnectionArrow(obj);

                        // PF-4009 Context menu disappears if any path selected during right-click
                        if ( option.e.button !== 2) {
                            listService.currentSelectedPathId = obj.model.get('id');
                            that.switchProperties(obj.model);
                            util.updateHelpDocumentationLink('connection_arrow_workflow');
                        }

                        break;
                    case 'group':
                        const fcanvas = listService.fcanvas;
                        const self = this;
                        let movedControls = [],
                            movedControlsAfter = [],
                            skipMove = false;

                        let activeObject = fcanvas.getActiveObject(),
                            activeGroup = fcanvas.getActiveGroup();

                        // PF-4009 Context menu disappears if any object selected during right-click
                        if (activeObject && option.e.button !== 2) {
                            that.switchProperties(activeObject.model);
                        }

                        if (obj.model && (!activeGroup)) {
                            const oldX = obj.model.get('x');
                            const oldY = obj.model.get('y');

                            const targetLeft = option.target.left < 0 ? option.target.left * -1 : option.target.left;
                            const targetTop = option.target.top < 0 ? option.target.top * -1 : option.target.top;

                            if (oldX === option.target.left && oldY === option.target.top) {
                                return; // don't record a move if it was just clicked, not moved.
                            }


                            movedControls.push({
                                id: obj.model.get('id'),
                                y: obj.model.get('y'),
                                x: obj.model.get('x'),
                                width: obj.model.get('width'),
                                height: obj.model.get('height'),
                                factoryKey: obj.model.get('factoryKey')
                            });
                            obj.model.set({ 'y': targetTop, 'x': targetLeft }, constants.MODEL_SILENT);
                            movedControlsAfter.push({
                                id: obj.model.get('id'),
                                y: obj.model.get('y'),
                                x: obj.model.get('x'),
                                width: obj.model.get('width'),
                                height: obj.model.get('height'),
                                factoryKey: obj.model.get('factoryKey')
                            });

                            // check if out of bounds
                            that.checkObjectLocation(fcanvas, option.target.top, option.target.left, obj.model, undefined, activeObject);

                            undoService.add({
                                undo: () => {
                                    self._processMovedControls(movedControls, []);
                                },
                                redo: () => {
                                    self._processMovedControls(movedControlsAfter, []);
                                }
                            }, textConstants.UNDO_MOVE);
                        }

                        if (activeGroup) {
                            let movedControls = [],
                                movedControlsAfter = [];

                            let grpLeft = activeGroup.left < 0 ? activeGroup.left * -1 : activeGroup.left;
                            let grpTop = activeGroup.top < 0 ? activeGroup.top * -1 : activeGroup.top;
                            const grpWidth = activeGroup.width;
                            const grpHeight = activeGroup.height;

                            _.forEach(activeGroup._objects.filter(w => w.model), function (obj) {
                                const left = (grpWidth / 2) + obj.left + grpLeft;
                                const top = (grpHeight / 2) + obj.top + grpTop;

                                const oldX = obj.model.get('x');
                                const oldY = obj.model.get('y');
                                if (oldX === left && oldY === top) {
                                    skipMove = true;
                                    return; // don't record a move if it was just clicked, not moved.
                                }

                                movedControls.push({ id: obj.model.get('id'), y: obj.model.get('y'), x: obj.model.get('x'), width: obj.model.get('width'), height: obj.model.get('height'), factoryKey: obj.model.get('factoryKey') });
                                obj.model.set({ 'y': top, 'x': left }, constants.MODEL_SILENT);
                                if (obj.model.get('factoryKey') !== 'connection_arrow') {
                                    obj.model.resetLastState();
                                }
                                movedControlsAfter.push({ id: obj.model.get('id'), y: obj.model.get('y'), x: obj.model.get('x'), width: obj.model.get('width'), height: obj.model.get('height'), factoryKey: obj.model.get('factoryKey') });
                            });
                            // check if out of bounds
                            that.checkObjectLocation(fcanvas, 0, 0, obj.model, activeGroup, activeGroup);

                            if (!skipMove) {
                                undoService.add({
                                    undo: () => {
                                        self._processMovedControls(movedControls, activeGroup);
                                    },
                                    redo: () => {
                                        self._processMovedControls(movedControlsAfter, activeGroup);
                                    }
                                }, textConstants.UNDO_MOVE);
                            }

                        }
                        break;
                }            
            }
        });


        fcanvas.off('object:selected');
        fcanvas.on('object:selected', option => {

            objectUtil.checkCtrlSelection(option, listService.workflowStages.toArray().concat(listService.workflowComments.toArray()));

            //  Fabric Js was modified on method _shouldGroup in order to avoid the shift key selection
            // console.log('on object selected');
            var that = this;
            const adjustedScale = MIN_CONTROL_WIDTH/option.target.width;

            option.target.hasBorders = true;
            if (option.target && option.target.type === 'ConnectionArrow') {
                option.target.hasBorders = false;
            }
            option.target.hasControls = false;

            if ( fcanvas.getActiveGroup() ) {
                option.target.hasControls = false;
            } else {
                if (option.target.model && option.target.model.get('factoryKey') === 'workflow_comment') {
                    option.target.minScaleLimit = adjustedScale;
                    option.target.lockScalingFlip = true;
                    option.target.lockScalingX = false;
                    option.target.lockScalingY = false;
                    option.target.hasControls  = true;
                }
            }

            function selectingOnlyConnectors(target){
                let result = false;
                if (target._objects && target._objects.length === 2) {
                    let onlyArrows = true;
                    _.forEach(target._objects, function (obj) {
                        if (obj.model.attributes.factoryKey !== 'connection_arrow') {
                            onlyArrows = false;
                        }
                    } );
                    if (onlyArrows) {
                        result = true;
                    }
                }
                return result;
            }

            // Note: if you receive a ticket wanting drag-selection of a single connection, then move this call to follow the if(activeObject) below
            this.evictConnectionsFromMultiSelection(fcanvas);

            //If multi-select is used return null if only one item was selected properties need to be shown 
            const  activeObject = fcanvas.getActiveObject();
            if(activeObject){
                if (selectingOnlyConnectors(option.target)) {
                    // avoid selecting only connectors
                    listService.fcanvas.discardActiveObject();
                    listService.fcanvas.discardActiveGroup();
                    listService.fcanvas.renderAll();
                } else {
                    // normal process
                    if (activeObject.model && activeObject.model.get('factoryKey') === 'connection_arrow') {
/*                  NOT necessary.  selectWorkflowConnection event will take care of this, and we will avoid
                  problems on rendering workflow connection properties more than one time (which is causing
                  to create 3 or more edit behavior buttons and causing to have 3 behavior canvas at same time*/
//                        this.selectConnectionArrow(activeObject);
                    }
                    else if (activeObject.model && activeObject.model.has('factoryKey')) {
                        util.updateHelpDocumentationLink(activeObject.model.get('factoryKey'));
                    }
                    if (!option.e){
                        that.switchProperties(activeObject.model);
                    }
                }
            }
            // Note: if you receive a ticket wanting drag-selection of a single connection, then enable this call after removing the call prior to if(activeOejct)
            // this.evictConnectionsFromMultiSelection(fcanvas);            
            
            listService.countingValidObjects();
            util.validateMenuItems( listService.selectedCount );
        });


        // PF-2322: Bring to front the hovered stage
        fcanvas.off('mouse:over');
        fcanvas.on('mouse:over', function(e) {
            const obj = e.target,
                canvasWidth = listService.fcanvas.getWidth();

            if ( that.isValidWorkflowObject(e) ) {
                e.target.bringToFront();
                listService.fcanvas.renderAll()
            }
            if (obj.model && obj.model.get('factoryKey') !== 'connection_arrow') {
                if (obj.item(0).textOverflown) {
                    const entireText = obj.model.get('factoryKey') === 'workflow_comment'
                        ? obj.model.get('text')
                        : obj.model.get('widgetText');

                    listService.fcanvas.add(new TooltipClass(entireText, obj, TOOLTIP_WIDTH, canvasWidth));
                }
            }
          });

          fcanvas.off('mouse:out');
          fcanvas.on('mouse:out', function(e) {
              if (!e.hasOwnProperty('drawing')) {
                  const objecstToDelete = [];
  
                  listService.fcanvas.getObjects().forEach(o=>{
                      if (o.isTooltip) {
                          objecstToDelete.push(o);
                      }
                  });
  
                  for (let i=0 ; i<=objecstToDelete.length ; i++) {
                      listService.fcanvas.remove(objecstToDelete[i]);
                  }
              }
          });
        
        fcanvas.off('object:scaling');
        fcanvas.on('object:scaling', function(e){
            that.scaling = true;
            const obj = e.target;
            const scaleX = obj.get('scaleX') > 0 ? obj.get('scaleX') : 0.0001;
            const scaleY = obj.get('scaleY') > 0 ? obj.get('scaleY') : 0.0001;

            obj.item(0).set({
                width: obj.get('width')*scaleX,
                height: obj.get('height')*scaleY,
                scaleX: 1/scaleX,
                scaleY: 1/scaleY
            });
        });

        fcanvas.off('mouse:move');
        fcanvas.on('mouse:move', function(option) {
            if (!option.target) {
                $('input').trigger('blur');
                $('textarea').trigger('blur');
            }
        });

        fcanvas.off('object:modified');
        fcanvas.on('object:modified', function(e) {

            if (e.target.model) {
                let arrowConnector;

                if (e.target.model.get('factoryKey') === "workflow_stage") {
                    let id = e.target.model.get('id');
                    let arrow = fcanvas.getObjects()
                            .filter(o => o.model.attributes.factoryKey === "connection_arrow")
                            .find(a => a.model.get('destWidgetModel').id === id ||  a.model.get('srcWidgetModel').id === id)
    
                    if (arrow && arrow.model) {
                        arrowConnector = arrow;
                    }  
    
                } else if (e.target.model.get('factoryKey') === "connection_arrow"){ 
                    console.log("Connector", e.target.model.get('factoryKey'));   
    
                    arrowConnector = e.target;
                }

                /* PF-4054 Following calculation assumed straight paths.  ConnectionArrowClass calculates its
                for either kind of path. See ConnectionArrowClass.drawWorkflowMarkers.
                */
                /*if (arrowConnector) {
                    let point = {
                        x: (arrowConnector.x1 + arrowConnector.x2) / 2,
                        y: (arrowConnector.y1 + arrowConnector.y2) / 2,
                        width: 50,
                        height: 10
                    };

                    point.path = {
                        x: point.x - point.width - point.height,
                        y: point.y - point.width - point.height
                    }
            
                    listService.pathDrawnNamesCoord[arrowConnector.model.get('id')] = point;
    
                    console.log("Connector", listService.pathDrawnNamesCoord);
                }*/
            }







            if (that.scaling) {
                let obj = e.target,
                    scale = {x:obj.scaleX, y:obj.scaleY},
                    newDim = {
                        x: obj.width*scale.x > MIN_CONTROL_WIDTH ? obj.width*scale.x :MIN_CONTROL_WIDTH,
                        y: obj.height*scale.y > MIN_CONTROL_HEIGHT ? obj.height*scale.y : MIN_CONTROL_HEIGHT
                    };

                const activeObject = listService.fcanvas.getActiveObject();
                if (activeObject) {
                    activeObject.model.set({'width': newDim.x, 'height': newDim.y}, constants.MODEL_SILENT);
                    listService.fcanvas.renderAll();
                }
                that.scaling = false;
            }
        });

        // Init sticky connection support
        super.supportStickyConnections( fcanvas );

        this.startWorkflowPageListeners( constants.UPPER_CANVAS_CLS );
        connectionController.runStateMachine(fcanvas, true);

        return this;
    }

    selectConnectionArrow(w) {
        // Preventing the movement of a connection arrow
        w.lockMovementX = true;
        w.lockMovementY = true;

        listService.currentSelectedPathId = w.model.get('id');
        util.updateHelpDocumentationLink('connection_arrow_workflow');
        this.switchProperties(w.model);
    }

    _processMovedControls(controls, activeGroup) {
        const self = this;
        const fcanvas = listService.fcanvas;
        const locked = true;

        _.forEach(controls, function (c) {

            if (c.factoryKey === 'connection_arrow') {

                const connection = listService.getWorkflowPath(c.id);
                connection.model.set(c, constants.MODEL_SILENT);


                const cinfo = util.getCommandCoordInfo(connection);
                const opts = constants.LINE_MODEL_OPTIONS;
                opts.model = connection.model;
                const line = new ConnectionArrowClass(cinfo.coords, opts);

                listService.fcanvas.remove(connection.line);

                if (listService.mainKind === constants.KIND_WORKFLOW) {
                    line.left = line.x1 < line.x2 ? line.x1 : line.x2;
                    line.top = line.y1 < line.y2 ? line.y1 : line.y2;
                    line.width = Math.abs(line.x2 - line.x1);
                    line.height = Math.abs(line.y1 - line.y2);
                    listService.fcanvas.add(line);
                }
                self.updateConnectionLineOnObject(line, connection);

            } else {
                const cmd = listService.getWorkflowStageOrComment(c.id);
                const oldX = cmd.model.get('x');
                const oldY = cmd.model.get('y');
                cmd.model.set(c, constants.MODEL_SILENT);
                cmd.model.resetLastState();
                cmd.rerender();
                connectionController.updateConnection(cmd.model, {x1: cmd.model.get('x'),
                    x2: oldX,
                    y1: cmd.model.get('y'),
                    y2: oldY});
            }
        });

        _.forEach(activeGroup._objects, function(obj) {
            fcanvas.remove(obj);
            //activeGroup.removeWithUpdate(obj);
        });
        fcanvas.discardActiveGroup();
        fcanvas.renderAll();
    }


    //==========================================================================
    // Implements standard BackBone View render method.
    //==========================================================================
    render() {
        this.$el.html( template(this.model.toJSON()) );
        this.initCanvas();
        this.delegateEvents();

        return this;
    }

    switchProperties( model ) {
        focusController.clearAllSelected();

        listService.objectList.map( view => {
            if ( view.subviews ) {
                view.subviews.map( (propertyView) => {
                    propertyView.undelegateEvents();
                });
            }
        });

        //PF-6568 - workflow behaviours looks duplicated
        this._subviews && this._subviews.forEach((_subview) => {
            _subview.undelegateEvents();
        });

        if (model) {
            $(constants.PROP_BHVR_ID)
            if (model.attributes.factoryKey==='connection_arrow'){
            this._subviews = Immutable.Map()
                .set('attributesView', new AttributesView({model: model, el: $(constants.PROP_ATTRIBUTES_ID)}))
                .set('behaviorView', new CustomBehaviorView({model: model, el: $(constants.PROP_BHVR_ID)}))
                .set('summaryView', new TabSummaryView({model: model, el: $(constants.PROP_TAB_SUMMARY_ID), type: 'workflow'}))
                .set('settingsView', new TabSettingsView({model: model, el: $(constants.PROP_SETTNGS_ID), type: 'workflow'}));
            }else{
            $(constants.PROP_BHVR_ID).empty();
            this._subviews = Immutable.Map()
                .set('attributesView', new AttributesView({model: model, el: $(constants.PROP_ATTRIBUTES_ID)}))
                .set('summaryView', new TabSummaryView({model: model, el: $(constants.PROP_TAB_SUMMARY_ID), type: 'workflow'}))
                .set('settingsView', new TabSettingsView({model: model, el: $(constants.PROP_SETTNGS_ID), type: 'workflow'}));
            }

            if (this._subviews) {
                this.delegateEvents();
                this._subviews.map(pview => {
                    pview.render();
                    pview.delegateEvents();
                });
            }
        }

        $('#settings-tab a').click();
    }

    triggerItemSelection() {
        this.switchProperties(listService.fcanvas.getActiveObject().model);
    }

}

export default WorkflowPageView;
